export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26')
];

export const server_loads = [];

export const dictionary = {
		"/": [2],
		"/case_studies": [3],
		"/case_studies/casestudy1": [4],
		"/case_studies/casestudy2": [5],
		"/case_studies/casestudy3": [6],
		"/case_studies/casestudy4": [7],
		"/case_studies/casestudy5": [8],
		"/case_studies/casestudy6": [9],
		"/climate_services_gateway": [10],
		"/climate_services_gateway/collections": [11],
		"/climate_services_gateway/file_info": [12],
		"/imprint": [13],
		"/provenance": [14],
		"/publications": [15],
		"/search_collection_fabian": [17],
		"/search": [16],
		"/team": [18],
		"/view_geotiff": [19],
		"/water_budget": [20],
		"/work_packages": [21],
		"/work_packages/wp1": [22],
		"/work_packages/wp2": [23],
		"/work_packages/wp3": [24],
		"/work_packages/wp4": [25],
		"/work_packages/wp5": [26]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),

	reroute: (() => {})
};

export { default as root } from '../root.svelte';